<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Modal" });
import "tailwindcss/tailwind.css";
import Icon from "../../elements/icon/Icon.svelte";
import Overlay from "../overlay/Overlay.svelte";
import { closeModal, decode } from "../../common/modal.js";
import { onMount, onDestroy, createEventDispatcher } from "svelte";
export let hash = "#fallback";
export let closeOnOutsideClick = true;
export let width = "400px";
export let height = "auto";
export let color = "white";
const dispatch = createEventDispatcher();
const checkOpen = (hash2) => window.location.hash.split("?")[0] === hash2;
let isOpen = checkOpen(hash);
const exitModal = () => {
    closeModal();
    dispatch("close");
};
const onHashChange = () => {
    isOpen = checkOpen(hash);
};
onMount(() => {
    window.addEventListener("hashchange", onHashChange, true);
});
onDestroy(() => {
    window.removeEventListener("hashchange", onHashChange, true);
});
</script>

{#if isOpen}
    <Overlay on:close = { closeModal } { isOpen } { width } { height } { closeOnOutsideClick } { hash } { color }>
        <Icon on:click = { exitModal } key = 'close' css = 's8-close-icon' />
            <div class = 's8-modal-body'>
                <slot parameters = { decode(window.location.hash) }>
                    Hello World
                </slot>
            </div>
    </Overlay>
{/if}